<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 56 40"
  >
    <defs>
      <linearGradient :id="glossId" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stop-color="#4a4a4a"/>
        <stop offset="15%" stop-color="#3a3a3a"/>
        <stop offset="50%" stop-color="#2a2a2a"/>
        <stop offset="85%" stop-color="#252525"/>
        <stop offset="100%" stop-color="#1f1f1f"/>
      </linearGradient>
      <linearGradient :id="highlightId" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stop-color="#ffffff" stop-opacity="0.25"/>
        <stop offset="50%" stop-color="#ffffff" stop-opacity="0"/>
      </linearGradient>
    </defs>

    <rect
      x="2"
      y="2"
      width="52"
      height="36"
      rx="6"
      ry="6"
      :fill="`url(#${glossId})`"
      stroke="#1a1a1a"
      stroke-width="2"
    />

    <rect
      x="4"
      y="4"
      width="48"
      height="16"
      rx="4"
      ry="4"
      :fill="`url(#${highlightId})`"
    />

    <text
      x="28"
      y="22"
      text-anchor="middle"
      dominant-baseline="middle"
      font-family="Arial, sans-serif"
      font-size="14"
      font-weight="bold"
      fill="#ffffff"
    >TAB</text>
  </svg>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'

let instanceCounter = 0

@Options({
  name: 'KeyTab',
  props: {
    width: {
      type: [Number, String],
      default: 56,
    },
    height: {
      type: [Number, String],
      default: 40,
    },
  },
})
export default class KeyTab extends Vue {
  private instanceId = `keyTab-${++instanceCounter}`

  get glossId(): string {
    return `${this.instanceId}-gloss`
  }

  get highlightId(): string {
    return `${this.instanceId}-highlight`
  }
}
</script>
